import React from "react";
import classNames from "classnames/bind";

import styles from "./StatusPanel.module.scss";
const cx = classNames.bind(styles);

type StatusPanelItemProps = {
  item: {
    label: string;
    value: any;
  };
};

const StatusPanelItem = ({ item }: StatusPanelItemProps) => {
  return (
    <div className={cx("itemContainer")}>
      <div className={cx("label")}>{item.label}</div>
      <div className={cx("value")}>{item.value ?? "-"}</div>
    </div>
  );
};

export default StatusPanelItem;
